<div class="ki-erste-nutzung" data-testid="ki-erste-nutzung">
  <button
    type="button"
    class="ki-erste-nutzung__overlay"
    tabindex="-1"
    [attr.aria-label]="'ki.ersteNutzung.abbrechen' | translate"
    (click)="abgebrochen.emit()"
  ></button>
  <div
    class="ki-erste-nutzung__dialog"
    role="dialog"
    aria-modal="true"
    cdkTrapFocus
    [cdkTrapFocusAutoCapture]="true"
    [attr.aria-labelledby]="titelId"
    (keydown.escape)="escape($event)"
  >
    <div class="ki-erste-nutzung__kopf">
      <app-ki-mark [size]="26" />
      <h2 class="ki-erste-nutzung__titel" [id]="titelId">{{ 'ki.ersteNutzung.titel' | translate }}</h2>
    </div>
    <div class="ki-erste-nutzung__koerper">
      <!-- Prettier bräche vor „)“ um, das würde als Leerzeichen sichtbar. -->
      <!-- prettier-ignore -->
      <p>
        {{ 'ki.ersteNutzung.sendenAn' | translate }} <strong>{{ verbindung().anbieter }}</strong>
        ({{ verbindung().modell }}, {{ 'ki.ersteNutzung.region' | translate }} <strong>{{ regionKey() ? (regionKey()! | translate) : verbindung().region }}</strong>){{ 'ki.ersteNutzung.gesendet' | translate }}
      </p>
      <p>{{ 'ki.ersteNutzung.pruefen' | translate }}</p>
    </div>
    <div class="ki-erste-nutzung__fuss">
      <button
        mat-stroked-button
        type="button"
        class="ki-erste-nutzung__abbrechen"
        data-testid="ki-erste-nutzung-abbrechen"
        (click)="abgebrochen.emit()"
      >
        {{ 'ki.ersteNutzung.abbrechen' | translate }}
      </button>
      <button
        mat-flat-button
        type="button"
        class="ki-erste-nutzung__verstanden"
        data-testid="ki-erste-nutzung-verstanden"
        (click)="verstanden.emit()"
      >
        {{ 'ki.ersteNutzung.verstanden' | translate }}
      </button>
    </div>
  </div>
</div>
